import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import Sidebar from '../EcoClub/Sidebar';
import EcoClub2026 from '../EcoClub2026';



const EcoClub3Class2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass3/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass3/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass3/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass3/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass3/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass3/6.webp`;


  const photos = [
    {
        src: p1,
        source: p1,
        rows: 1,
        cols: 1,
    },
    {
        src: p2,
        source: p2,
        rows: 1,
        cols: 1,
    },
    {
        src: p3,
        source: p3,
        rows: 1,
        cols: 1,
    },
    {
        src: p4,
        source: p4,
        rows: 1,
        cols: 1,
    },
    {
        src: p5,
        source: p5,
        rows: 1,
        cols: 1,
    },
    {
        src: p6,
        source: p6,
        rows: 1,
        cols: 1,
    }

  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center' >
     SUSTAINABLE LUNCH BOX
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
      Class: 3  &  Date: 29 June 2026
        </Typography>
        {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
"Time spent among trees is never time wasted. Let’s embark on a Journey into Nature"

        <br/>
        </Typography> */}
        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        As part of the Eco Club initiative, Class 3 students actively participated in the activity<strong>‘SUSTAINABLELUNCH BOX’</strong> on Monday, 29 June 2026. The objective of the programme was to create awareness
among the students on compost pit which helps the students to identify and evaluate biodegradable
or recyclable materials suitable for food containers. This also helped them to analyse how product
choices affect waste reduction apply creative problem-solving to balance functionality, aesthetics and
understand how everyday products influence sustainable consumption patterns and utilise them in compost pit.
           
        <br></br>
            The students were asked to bring the healthy green snacks like fruits and vegetables in a box along
with its peels in another box. The compost pit was designed and placed in the school garden and
students were asked to dump the peels in the compost pit. This activity made them eager to know
the conversion of biodegradable waste into compost. Students were encouraged eco-friendly
behaviour like reducing food waste, reusing organic matter and inspiring broader participation in
sustainability initiatives within and beyond school.
        <br></br>
        This project nurtures both scientific curiosity and civic responsibility — turning waste into a learning
opportunity.
 <br></br>
        </Typography>
      </Box>
      

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <EcoClub2026   />
             </Box>
             <Box marginBottom={4}>
               <Sidebar />
             </Box>


    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default EcoClub3Class2026;